import React, { useEffect } from 'react';

import Card from '~/components/Card';
import { Button, Form } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { fetchGearApi, deleteGearApi, toggleGearPublishedStateApi } from './gearSlice.js';
import EditDeleteBtn from '~/components/EditDeleteBtn';
import Datatable from '~/components/Datatable';

function Gear() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { rows } = useSelector((state) => state.itemSaga.gear);

    const columns = React.useMemo(
        () => [
            {
                name: '#',
                selector: (row) => row.id,
            },
            {
                name: 'Name',
                selector: (row) => row.name,
                sortable: true,
            },
            {
                name: 'Description',
                selector: (row) => row.description,
                sortable: true,
                width: '16rem',
            },
            {
                name: 'Edit/Remove',
                cell: (row) => (
                    <EditDeleteBtn
                        row={row}
                        thunkFunc={deleteGearApi}
                    />
                ),
            },
            {
                name: 'Published',
                cell: (row) => (
                    <Form.Check
                        type="switch"
                        id={'published-' + row.id}
                        onChange={() => {
                            dispatch(toggleGearPublishedStateApi(row));
                        }}
                        checked={row.is_ready}
                    />
                ),
            },
        ],
        [],
    );

    useEffect(() => {
        if (rows.length > 0) return;
        dispatch(fetchGearApi(navigate));
    }, []);

    return (
        <Card>
            <div className={'d-flex flex-row-reverse'}>
                <Link to={'create'}>
                    <Button className={'bg-info border border-info'}>Create</Button>
                </Link>
            </div>
            <div className="col-sm-12">
                <Datatable
                    columns={columns}
                    rows={rows}
                />
            </div>
        </Card>
    );
}

export default Gear;
//ref: https://codesandbox.io/s/react-bootstrap-formik-pb831?from-embed=&file=/src/form-section-1.js:436-570
/**Notes */
//(1) even though this is reset buttton, don't use type="reset" here as it will cause nested form fields (like FormikArray) unable to be reset to its inital values (I debugged and figured it out).
